/*---------------- Responsive Menu ------------------*/
$(".m-menu-btn").on('click', function (e) {
  $("body").toggleClass('off-canvas-body');
  $(".header-section").toggleClass("menu-open");
  $(this).toggleClass("m-menu-btn-ext");
  e.preventDefault();
});
$('nav.menu').on("click", ".has-submenu > a > span", function (e) {
  $(this).parent('a').next('.menu-dropdown').slideToggle(600);
  $(this).toggleClass('icon-down-arrow icon-up-arrow');
  e.stopPropagation();
  e.preventDefault();
});
$('nav.menu').on("click", ".has-multisubmenu > a > span", function (e) {
  $(this).parent('a').next('.menu-dropdown').slideToggle(600);
  $(this).toggleClass('icon-down-arrow icon-up-arrow');
  e.stopPropagation();
  e.preventDefault();
});

$(document).on('click touchstart', function(e) {
  if (!$(e.target).is('.m-menu-btn, .m-menu-btn , .header-section, .header-section *')) {
    $('.m-menu-btn, .header-section').removeClass('menu-open');
    if ($(".m-menu-btn").hasClass("m-menu-btn-ext")) {
      $(".m-menu-btn").removeClass("m-menu-btn-ext");
    }
  }

});

$(".search-item").on('click', function(e) {
  $(".header-section").toggleClass('search-active');
  e.preventDefault();
});
// close when click off of container
$(document).on('click touchstart', function(e) {
  if (!$(e.target).is('.search-item, .search-item *, .header-section, .header-section *')) {
    $('.search-item, .header-section').removeClass('search-active');

  }
});

/*---------------- Footer Mobile Menu ------------------*/

$('.f-title').on("click", function(e) {
  if ($(this).hasClass('menushow')) {
    remove_styles();
    $(this).removeClass('menushow');
    $(this).next('ul').removeClass('menushowtoggle');
    if($(this).next('ul').next('ul').length) {
      $(this).next('ul').next('ul').removeClass('menushowtoggle');
    }
  } else {
    remove_styles();
    $(this).addClass('menushow');
    $(this).next('ul').addClass('menushowtoggle');
    if($(this).next('ul').next('ul').length) {
      $(this).next('ul').next('ul').addClass('menushowtoggle');
    }
  }
  e.stopPropagation();
  e.preventDefault();
});

function remove_styles() {
  $('.f-title').each(function() {
    $(this).removeClass('menushow');
    $(this).next('ul').removeClass('menushowtoggle');
    if($(this).next('ul').next('ul').length) {
      $(this).next('ul').next('ul').removeClass('menushowtoggle');
    }
  });
}

/*---------------- main Banner ------------------*/
$(".main-banner-slider").slick({
  autoplay: false,
  dots: true,
  adaptiveHeight: true,
  autoplaySpeed: 5000,
  arrows: false,
});


$('.shop-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.shop-slider-nav'

});
$('.shop-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.shop-slider',
  dots: false,
  arrows: true,
  infinite: false,
  focusOnSelect: true,
  vertical:true,
  horizontalSwiping:true,
  responsive: [

    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical:false
        // horizontal:true,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:false
        // horizontal:true,
      }
    },   
    { 
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical:false
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical:false
      }
    }
  ]
});

/* Shop slider end*/

/*---------------- Products Slider Slider ------------------*/

$('.gallery-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1600,
    settings: {
      slidesToShow: 4
    }
  },

               {
                 breakpoint: 940,
                 settings: {
                   slidesToShow: 3
                 }
               },
               {
                 breakpoint: 767,
                 settings: {
                   slidesToShow: 2
                 }
               },
               {
                 breakpoint: 568,
                 settings: {
                   slidesToShow: 1
                 }
               }
              ]
});

/*related-slider*/  

$('.related-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  infinite: false,
  focusOnSelect: true,
  horizontal:true,
  horizontalSwiping:true,
  responsive: [

    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, 
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:false
        // horizontal:true,

      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical:false
        // horizontal:true,

      }
    },
    { 
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false
      }
    }


  ]
});

/*----------------Easy Responsive Tab ------------------*/

$(document).ready(function() {
  //Horizontal Tab
  $('#parentHorizontalTab').easyResponsiveTabs({
    type: 'default', //Types: default, vertical, accordion
    width: 'auto', //auto or any width like 600px
    fit: true, // 100% fit in a container
    tabidentify: 'hor_1', // The tab groups identifier
    activate: function(event) { // Callback function if tab is switched
      var $tab = $(this);
      var $info = $('#nested-tabInfo');
      var $name = $('span', $info);
      $name.text($tab.text());
      $info.show();
    }
  });

});



/* Qty */ 

$('.qty-btn.plus').click(function (e) {
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[name=' + fieldName + ']').val());
  // If is not undefined
  if (!isNaN(currentVal)) {
    // Increment
    $('input[name=' + fieldName + ']').val(currentVal + 1);
  }
  else {
    // Otherwise put a 0 there
    $('input[name=' + fieldName + ']').val(1);
  }
});
// This button will decrement the value till 0
$(".qty-btn.minus").click(function (e) {
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[name=' + fieldName + ']').val());
  // If it isn't undefined or its greater than 0
  if (!isNaN(currentVal) && currentVal > 1) {
    // Decrement one
    $('input[name=' + fieldName + ']').val(currentVal - 1);
  }
  else {
    // Otherwise put a 0 there
    $('input[name=' + fieldName + ']').val(1);
  }
});

/* Qty End */ 
/*----------------FAQ accordion------------------*/

$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.article-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);
});

/*----------------FAQ accordion----------end--------*/

/*---------------- contant height equal  ------------------*/

$(window).load(function() {
  equalheight('.location-inner p');
  //equalheight('.powerfull_row .same');
});
$(window).resize(function() {
  equalheight('.location-inner p');
  //equalheight('.powerfull_row .same');
});

/*-------------------------*/






